import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {}

    setCartCounter(length) {
        this.el.innerHTML = `(${length})`
    }

    destroy() {
        super.destroy();
    }
}